import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";
import { InputDateYYYYMMDD } from "../../../../../../../modules/theme/Input/InputDateYYYYMMDD ";

interface propsCustomFormsQuickTurn {
    objectData?: any;
    onChange?: Function;
    serviceRespose?: any;
    FormType: string;
}

export const CustomFormsQuickTurn = ({ FormType, objectData, onChange }: propsCustomFormsQuickTurn) => {

    const formRender = (formCode: string) => {

        console.log(formCode)
        switch (formCode) {

            case "01":
                return <div className="row">
                    <div className="col-md-6">
                        <InputDateYYYYMMDD
                            textFormat="YYYYMMDD"
                            label="Fecha Inicial"
                            name="fechaIni"
                            value={objectData.fechaIni}
                            onChange={(e) => onChange({ ...objectData, fechaIni: e })}
                        />

                    </div>

                    <div className="col-md-6">
                        <InputDateYYYYMMDD
                            textFormat="YYYYMMDD"
                            label="Fecha Final"
                            name="fechaFin"
                            value={objectData.fechaFin}
                            onChange={(e) => onChange({ ...objectData, fechaFin: e })}
                        />
                    </div>

                </div>;
            case "02":
                return <div className="row">
                    <div className="col-md-6">
                        <YearSelector returnAs="string" onChange={(e) => { onChange({ ...objectData, fechaIni: (e) }) }} tittle="Inicio" value={objectData.fechaIni} />
                    </div>
                    <div className="col-md-6">
                        <YearSelector returnAs="string" onChange={(e) => { onChange({ ...objectData, fechaFin: (e) }) }} tittle="Fin" value={objectData.fechaFin} />
                    </div>
                </div>;

            case "03":
                const response = objectData;

                if (!response || !response.tramites?.length) {
                    return (
                        <div className="alert alert-info">
                            No hay información de trámites para mostrar.
                        </div>
                    );
                }

                return (
                    <div className="row">
                        <div className="col-12 mb-3">
                            <div className="alert alert-success">
                                {response.errorDescription}
                            </div>
                        </div>

                        {response.tramites.map((tramite: any, index: number) => (
                            <div className="col-12 mb-4" key={index}>
                                <div className="card shadow-sm">
                                    <div className="card-body">

                                        {/* Header */}
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h6 className="mb-0">
                                                Solicitud #{tramite.solicitud}
                                            </h6>

                                            <span className="badge bg-success">
                                                {tramite.estado}
                                            </span>
                                        </div>

                                        {/* Info básica */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <small className="text-muted">Fecha radicación</small>
                                                <div>{tramite.fechaRadicacion}</div>
                                            </div>

                                            <div className="col-md-4">
                                                <small className="text-muted">Valor solicitado</small>
                                                <div className="fw-bold">
                                                    {tramite.valorSolicitado}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Timeline */}
                                        <div>
                                            <small className="text-muted">Detalle del trámite</small>
                                            <ul className="list-group list-group-flush mt-2">
                                                {tramite.detalle.map((step: any, i: number) => (
                                                    <li
                                                        key={i}
                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                    >
                                                        <span>{step.estacion}</span>
                                                        <span className="badge bg-secondary">
                                                            {step.estado}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                );


            default:
                break;
        }

    }


    return formRender(FormType);
}